
import React from 'react';
import {
    makeStyles,
    LinearProgress,
    Dialog,
    DialogContent,
} from '@material-ui/core';


const useStyles = makeStyles(theme => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(2),
    },
    progress: {
        marginTop: theme.spacing(1),
    }
}));

const SendingDialog: React.FC<{ open: boolean, onClose: () => void }> = (props) => {
    const classes = useStyles();
    return (
        <Dialog
            // fullScreen={true}
            open={props.open}
            onClose={() => props.onClose()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent className={classes.wrapper}>
                Отправляем замечания...
                    <LinearProgress className={classes.progress} />
            </DialogContent>
        </Dialog>
    );
}
export default SendingDialog;